import React, { ReactElement, useState } from 'react';
import { SimpleBlock } from 'ui-builder';
import { DependentTasksSummary } from './DependentTasksSummary';
import styles from './DependentTasksSummary.module.scss';

export interface CollapsibleDependentTasksProps {
  dependentTasksCount: number;
  defaultExpanded?: boolean;
  children: ReactElement;
}

export function CollapsibleDependentTasks(props: CollapsibleDependentTasksProps) {
  const [isExpanded, setIsExpanded] = useState(props.defaultExpanded ?? true);

  const handleToggle = () => {
    setIsExpanded((prev) => !prev);
  };

  if (props.dependentTasksCount === 0) {
    return null;
  }

  if (isExpanded) {
    return (
      <>
        <DependentTasksSummary
          count={props.dependentTasksCount}
          isCollapsed={false}
          onToggle={handleToggle}
        />
        <SimpleBlock className={styles.dependentTasksContainer}>
          {props.children}
        </SimpleBlock>
      </>
    );
  }

  return (
    <DependentTasksSummary
      count={props.dependentTasksCount}
      isCollapsed
      onToggle={handleToggle}
    />
  );
}
